<script setup lang="ts">
const menuStore = useMenuStore()
const { collapseMenus } = menuStore
const { isMenuCollapsed, isChangeAreaMenuCollapsed } = storeToRefs(menuStore)
const { showAdminInterface } = storeToRefs(useAuthStore())
const menuOverlayVisible = computed(
  () => !isMenuCollapsed.value || !isChangeAreaMenuCollapsed.value,
)
const menuOverlayClass = computed(() => menuOverlayVisible.value
  ? 'z-[91] lg:z-[91]'
  : 'pointer-events-none')
const menuOverlayStyle = computed(() => ({
  backdropFilter: menuOverlayVisible.value ? 'blur(3px)' : 'blur(0px)',
  backgroundColor: menuOverlayVisible.value ? 'rgb(227 227 227 / 0.6)' : 'transparent',
}))
</script>

<template>
  <div
    class="grid grid-rows-[3rem_calc(100vh-3rem)] overflow-hidden md:grid-rows-[3rem_calc(100vh-7rem)_4rem]">
    <Header />
    <div
      class="flex overflow-hidden bg-secondary-gray-300 2xl:bg-secondary-gray-100"
      :class="{ 'bg-white 2xl:bg-white': showAdminInterface }">
      <AdminMenu v-if="showAdminInterface" />
      <SiteAssessmentMenu v-else />
      <div class="mx-auto min-w-0 flex-1 overflow-x-hidden overflow-y-auto 2xl:max-w-[1960px]">
        <slot />
      </div>
      <ChangeAreaMenu />
    </div>
    <div
      class="z-30 hidden border border-secondary-gray-300 bg-secondary-gray-100 px-spacing-2xl py-spacing-sm md:flex">
      <SvgoSecuritasTextLogoBlack
        v-if="!$isProtectasUser.value"
        class="size-14" />
      <SvgoProtectasTextLogoBlack v-else class="size-14" />
    </div>
  </div>
  <DimOverlay
    class="transition-[backdrop-filter,background-color] duration-300 ease-in"
    :class="menuOverlayClass"
    :style="menuOverlayStyle"
    @click="collapseMenus" />

  <InstallAppPrompt />
  <Notification />
</template>
